import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../components/common";
import { pathConstants } from "../../../routes/pathContants";
import secondaryComponents from "../../../components/secondaryComponents";

export const BillsHome = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Bills"
      headerDescription="Manage your list of generated bills"
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <secondaryComponents.BillsWidget />
    </RoutedModal>
  );
};
